import FormController from "../form_controller";

export default class extends FormController {
    async submit(event: SubmitEvent) {
        await super.submit(event);
        this.dispatch("dataHasChanged", { prefix: "" });
    }
}
